import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';

import { SyllabusModel } from 'app/services/models/user-detail-model';
import { UnifiedAuthService } from 'app/services/yoklama/auth.service';
import { CMSDynamicService } from 'app/services/yoklama/cms-service';
import { DeviceService } from 'app/services/yoklama/devices-services';

@Component({
  selector: 'app-syllabus-screen',
  templateUrl: './syllabus-screen.component.html',
  styleUrls: ['./syllabus-screen.component.css'],
})
export class SyllabusScreenComponent implements OnInit, AfterViewInit {
  weekdays = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma'];
  selectedTab = 0;
  private readonly ATTENDANCE_CACHE_KEY = 'attendance_cache';

  isLoading = true;
  syllabusList: SyllabusModel[] = []; // localStorage'dan çekilecek

  constructor(
    private router: Router,
    private httpService: CMSDynamicService,
    private deviceService: DeviceService,

    private alertService: CustomToastrService,
    private loginservice: UnifiedAuthService,
  ) {}
  ngAfterViewInit() {
    const slider = document.querySelector('.draggable-tabs') as HTMLElement;
    let isDown = false;
    let startX: number;
    let scrollLeft: number;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      // e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1; // hız
      slider.scrollLeft = scrollLeft - walk;
    });
  }
  isMobile = this.deviceService.isMobile;

  deviceRegistred = true;
  async ngOnInit(): Promise<void> {
   if (!this.deviceService.isMobile) {
      this.alertService.message(
        'Yoklamalar, Wi-Fi doğrulaması ve GPS ile konum tespiti yapılabilmesi için yalnızca mobil cihazlardan gerçekleştirilmektedir. Lütfen mobil cihaz üzerinden giriş yapınız.',
        'Uyarı',
        {
          messageType: ToastrMessageType.Warning,
          position: ToastrPosition.TopFullWidth,
        },
      );
      setTimeout(() => {
        this.router.navigate(['/welcome']);
      }, 3000);
      return;
    }
    var deviceId = this.deviceService.getServerDeviceId();
    const isRegistered = await this.deviceService.checkDeviceRegistered(
      deviceId ?? '',
    );

    if (!isRegistered) {
      this.alertService.message(
        'Cihaz kayıtlı değil. Lütfen cihazınızı kaydedin veya destek ekibi ile iletişime geçin.',
        'Uyarı',
        {
          messageType: ToastrMessageType.Warning,
          position: ToastrPosition.TopFullWidth,
        },
      );
      setTimeout(() => {
        this.router.navigate(['/cihaz-yonetimi']);
      }, 1000);
      return;
    }
    this.loadSyllabusFromLocal(true); // buradaki true kaldırılırsa local storage kaydedip veri çeker sunucu yuku kalkar ama attendaceinfo dolmayacağı için yoklama başlatamaz butona yoklama kontrol et adı verilip bu durum çözülebilir
  }

  replaceAttendanceInfo(info: any): void {
    if (!info?.courseStartId) return;

    const raw = localStorage.getItem(this.ATTENDANCE_CACHE_KEY);
    const cache = raw ? JSON.parse(raw) : {};

    // 🔥 eskiyi sil (zaten overwrite ama niyet net)
    delete cache[info.courseStartId];

    // 🔥 yeniyi yaz
    cache[info.courseStartId] = info;

    localStorage.setItem(this.ATTENDANCE_CACHE_KEY, JSON.stringify(cache));
  }
getQrButtonClass(item: any): string {
  // 1. Eğer attendanceInfo yoksa veya veri yükleniyorsa pasif görünsün
  if (!item.attendanceInfo) {
    return 'btn-secondary opacity-50 cursor-not-allowed';
  }

  const text = this.yoklamaText(item);

  // 2. Yoklama bittiyse kırmızı/gri (Pasif durum)
  if (text === 'Yoklama Bitti') {
    return 'btn-danger opacity-75';
  }

  // 3. Şu an aktif bir saat dilimi içerisindeyse (Örn: "1. Saat Yoklaması")
  if (text.includes('Saat')) {
    // Öğrencinin dikkatini çekmek için canlı bir yeşil veya mavi
    return 'btn-success shadow-pulse';
  }

  // 4. Varsayılan durum (Ders var ama henüz yoklama saati gelmedi veya bekliyor)
  return 'btn-primary';
}
  getColSizes(item: any) {
    const buttonCount = item.attendanceInfo ? 2 : 1; // Detay + yoklama
    const rightCol = Math.min(4 * buttonCount, 8); // max 8
    const leftCol = 12 - rightCol;
    return { left: leftCol, right: rightCol };
  }
  // ======================= LOCAL STORAGE =======================
  async loadSyllabusFromLocal(forceRefresh: boolean = false) {
    this.isLoading = true;

    const ogrenciNo = localStorage.getItem('ogrenciNumarasi');
    const programID = localStorage.getItem('programId');
    const version = localStorage.getItem('appVersion');

    // localStorage key'i öğrenciNo + programID ile oluştur
    const storageKey = `dersler_${ogrenciNo}_${programID}`;
    const storageUpdateKey = `derslerLastUpdate_${ogrenciNo}_${programID}`;

    // localStorage'daki dersler
    let localData = localStorage.getItem(storageKey);
    let localDataObj = localData ? JSON.parse(localData) : null;

    // son güncelleme zamanı
    const lastUpdate = localStorage.getItem(storageUpdateKey);
    const now = new Date().getTime();
    const oneMonth = 30 * 24 * 60 * 60 * 1000; // 1 ay

    // Eğer localData yoksa, 1 ay geçmişse veya forceRefresh true ise servisten çek
    if (
      !localDataObj ||
      !lastUpdate ||
      now - parseInt(lastUpdate) > oneMonth ||
      forceRefresh
    ) {
      try {
        const data = await this.httpService.get(
          0,
          2000,
          'Kapi',
          `GetListCourseStart?okulno=${ogrenciNo}&birimId=${programID}&version=${version}`,
        );



        this.syllabusList = data.syllabus[0] || [];

        // localStorage'a kaydet
        localStorage.setItem(storageKey, JSON.stringify(this.syllabusList));
        localStorage.setItem(storageUpdateKey, now.toString());
      } catch (err) {
        console.error('Servisten çekme hatası:', err);
        // hata durumunda localStorage'daki veriyi kullan
        this.syllabusList = localDataObj || [];
      }
    } else {

      this.syllabusList = localDataObj;
    }


    this.isLoading = false;
  }
  refreshSyllabus() {
    // forceRefresh = true ile servisten tekrar çek
    this.loadSyllabusFromLocal(true);
  }
  // ======================= FİLTRE =======================
  filterByDay(day: string) {
    const result = this.syllabusList
      .filter((d) => this.normalize(d.gunler!) === this.normalize(day))
      .sort((a, b) => (a.saat! > b.saat! ? 1 : -1))
      .map((d) => ({
        ...d,
      }));

    return result;
  }

  normalize(text: string): string {
    if (!text) return '';

    return text
      .toString()
      .replace(/\s+/g, ' ') // tüm whitespace'leri düzelt
      .replace(/^\s+|\s+$/g, '') // baş/son whitespace
      .replace(/\u00A0/g, '') // NBSP temizle
      .normalize('NFD') // UTF parçalama
      .replace(/[\u0300-\u036f]/g, '') // aksan temizle
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/Ş/g, 's')
      .replace(/ş/g, 's')
      .replace(/İ/g, 'i')
      .replace(/I/g, 'i')
      .replace(/ı/g, 'i')
      .replace(/Ç/g, 'c')
      .replace(/ç/g, 'c')
      .replace(/Ü/g, 'u')
      .replace(/ü/g, 'u')
      .replace(/Ö/g, 'o')
      .replace(/ö/g, 'o')
      .toLowerCase();
  }

  // ======================= SAAT FORMATLAYICI =======================
  formatTime(time: string): string {
    if (!time.includes('-')) return time;

    const [start, end] = time.split('-');
    return `${start.trim().substring(0, 5)} - ${end.trim().substring(0, 5)}`;
  }
  // ======================= DERS SAATİ DURUM CLASS =======================
  getSlotClass(slot: any, info: any): string {
    if (!info) return 'upcoming';

    // ✅ TEK SEFER
    if (info.attendanceMode === 'teksefer') {
      const attendedAll = info.ogrenciDersSaatleri.every(
        (x: any) => x.katildiMi,
      );
      return attendedAll ? 'present' : 'absent';
    }

    // ✅ SAAT BAŞI (mevcut mantık)
    const aktifSlot = info.totalSessionHours - info.slotCount;

    if (slot.slotNumber > aktifSlot) {
      return 'upcoming';
    }

    return slot.katildiMi ? 'present' : 'absent';
  }
  // ======================= SLOT LABEL =======================
  getSlotLabel(slot: any): string {
    return `${slot.slotNumber}. Saat`;
  }

  // ======================= YOKLAMA YAZISI =======================
  yoklamaText(item: any): string {
    const info = item.attendanceInfo;


    if (!info) return '';
    // ✅ TEK SEFER
    if (info.attendanceMode === 'teksefer') {
      if (info.obsStatus === true) {
        return 'Yoklama Bitti';
      } else {
        return 'Yoklamaya Katıl';
      }
    }

    if (info.slotCount === 0) {
      if (info.obsStatus === true) {
        return 'Yoklama Bitti';
      } else {
        return `Yoklamaya Katıl / ${info.totalSessionHours}. Saat`;
      }
    }

    if (info.slotCount > 0 && info.obsStatus === false) {
      const mevcutSaat = info.totalSessionHours - info.slotCount;
      return `Yoklamaya Katıl / ${mevcutSaat}. Saat`;
    }

    return 'Yoklamaya Katıl';
  }
  // Hangi dersin slotları açık
  openSlots: number | null = null;

  // Slotları aç / kapat
  toggleSlots(courseStartId: number) {
    this.openSlots = this.openSlots === courseStartId ? null : courseStartId;
  }

  // Aktif slot hesapla
  getActiveSlot(info: any): number {
    return info.totalSessionHours - info.slotCount;
  }

  // Katılım yüzdesi
  getAttendancePercent(info: any): number {
    const attended = info.ogrenciDersSaatleri.filter(
      (x: any) => x.katildiMi,
    ).length;
    return Math.round((attended / info.totalSessionHours) * 100);
  }

  // Slot class (pulse dahil)
  getGunNo(gunAdi: string): number {
    if (!gunAdi) return 0;

    // İlk harfi büyük, diğerleri küçük yap
    const formatted =
      gunAdi.charAt(0).toUpperCase() + gunAdi.slice(1).toLowerCase();

    switch (formatted) {
      case 'Pazartesi':
        return 1;
      case 'Salı':
        return 2;
      case 'Çarşamba':
        return 3;
      case 'Perşembe':
        return 4;
      case 'Cuma':
        return 5;
      case 'Cumartesi':
        return 6;
      case 'Pazar':
        return 7;
      default:
        return 0; // Tanınmayan gün
    }
  }
  getDateTimeFromWeekAndGunNo(gunNo: number, saat: string): Date {
    // Haftanın Pazartesi'sini bul (hafta pazartesiden başlıyorsa)
    const now = new Date();
    const pazartesi = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - (now.getDay() === 0 ? 6 : now.getDay() - 1),
    );
    const dersGunTarihi = new Date(
      pazartesi.getFullYear(),
      pazartesi.getMonth(),
      pazartesi.getDate() + (gunNo - 1),
    );
    // saat "HH:mm:ss" bekleniyor
    const parts = (saat || '00:00:00').split(':').map((p) => parseInt(p, 10));
    const saatInt = parts[0] || 0;
    const dakikaInt = parts[1] || 0;
    const saniyeInt = parts[2] || 0;
    return new Date(
      dersGunTarihi.getFullYear(),
      dersGunTarihi.getMonth(),
      dersGunTarihi.getDate(),
      saatInt,
      dakikaInt,
      saniyeInt,
    );
  }
  // ======================= QR SAYFASINA GİT =======================
  openQrPage(item: any) {
    var control = this.yoklamaText(item);

    if (control.includes('Yoklama Bitti')) {
      this.alertService.message(
        'Yoklamaya OBS üzerinden devam edebilirsiniz. Yoklama süresi dolmuş veya tüm saatler tamamlanmış olabilir.',
        'Bilgi',
        {
          messageType: ToastrMessageType.Warning,
          position: ToastrPosition.TopFullWidth,
        },
      );
      return;
    }

    const info = item.attendanceInfo;

    if (!info?.courseStartId) return;
    this.loadUserListFromLocalStorage();
    // 🔥 gitmeden önce cache güncelle
    this.replaceAttendanceInfo(info);


    const key = `courseStudent_${item.yoklamaNo}`;

    const payload = {
      ogrenciNo: item.ogrenciNumarasi,
      dersNo: item.dersNo,
      yoklamaNo: item.yoklamaNo,
      derSube: item.dersSube,
      derslik: item.derslik,
      courseStartId: info.courseStartId,
      haftalikDersId: info.haftalikDersId,
      gunler: item.gunler,
      saat: item.saat,
      totalSessionHours: info.totalSessionHours,
      slotCount: info.slotCount,
      isAllTaken: info.isAllTaken,
      acilanDersNo: info.acilanDersNo,
      acilanDersDetayNo: info.acilanDersDetayNo,
      akademikPersonelNo: info.akademikPersonelNo,
      qrUretAktif: info.qrUretAktif,
      konumKontrolAktif: info.konumKontrolAktif,
      attendanceDuration: info.attendanceDuration,
      createdDate: info.createdDate,
      latitude: info.latitude ?? 0,
      longitude: info.longitude ?? 0,
      studentName: this.studentName,
      studentSurname: this.studentSurname,
      ogrenciDersNo: item.ogrenciDersNo,
      gunNo: this.getGunNo(item.gunler),
      dersBaslangic: this.getDateTimeFromWeekAndGunNo(
        this.getGunNo(item.gunler),
        item.saat,
      ),
      dersBitis: this.getDateTimeFromWeekAndGunNo(
        this.getGunNo(item.gunler),
        item.saat,
      ),
    };

    localStorage.setItem(key, JSON.stringify(payload));

    this.router.navigate(['/derse-katil'], {
      queryParams: {
        yoklamaNo: item.yoklamaNo,
      },
    });
  }

  userList: any;
  studentName: string = '';
  studentSurname: string = '';
  // ngOnInit veya uygun bir yerde
  private loadUserListFromLocalStorage(): void {
    const raw = localStorage.getItem('userList');
    if (!raw) {
      console.warn('LocalStorage: userList bulunamadı');
      return;
    }

    try {
      this.userList = JSON.parse(raw);

      // Eğer data dizisi boş değilse ad ve soyad al
      if (this.userList?.data?.length > 0) {
        const student = this.userList.data[0];


        // token veya hub kullanırken de bunu kullanabilirsin
        this.studentName = student.ad;
        this.studentSurname = student.soyad;
      }
    } catch (err) {
      console.error('userList parse hatası:', err);
    }
  }
}
